/**
 * Role-aware "home" redirect. Sends the authenticated user to their
 * landing page — staff to app selection, support users to the customer
 * list, customers to their plant list — so non-staff never dead-end on
 * staff-only landing routes like /apps.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useUser } from '@sophocles/app';
import { homePath } from '@sophocles/router/checkCredentials';

function HomeRedirect() {
  const { user } = useUser();
  return <Navigate to={homePath(user)} replace />;
}

export default HomeRedirect;
